import { render, staticRenderFns } from "./Type.vue?vue&type=template&id=cbd7758c&scoped=true&"
import script from "./Type.vue?vue&type=script&lang=js&"
export * from "./Type.vue?vue&type=script&lang=js&"
import style0 from "./Type.vue?vue&type=style&index=0&id=cbd7758c&lang=scss&scoped=true&"
import style1 from "./Type.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbd7758c",
  null
  
)

export default component.exports